(function() {
    'use strict';

    angular
        .module('shared.api')
        .constant('apiDefaultEndpoint', '/api/internal');
})();
